import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  public toogleMenu = new BehaviorSubject<boolean>(false);

  constructor() {

  }
}
